import { useOrganization, useWebSite } from '~/composables/structured-data'
import * as t from '~/messages'
import { useGoogleSignIn } from '~/composables/google-sign-in'

export default defineNuxtPlugin({
  parallel: true,
  dependsOn: import.meta.server ? ['initial-data-state'] : undefined,
  setup() {
    const {
      public: { languageId },
    } = useRuntimeConfig()

    const languageCode = languageId === 1 ? 'et' : languageId === 2 ? 'fi' : 'ru'

    const defaultTitle = t['meta.title']()
    const titleAdd = t['meta.title.add']()

    useHead({
      titleTemplate: (title) => `${title ?? defaultTitle} - ${titleAdd}`,
      htmlAttrs: {
        lang: languageCode,
      },
      meta: [{ property: 'fb:app_id', content: '490770987692073' }],
    })

    useSchemaOrg([defineOrganization(useOrganization()), defineWebSite(useWebSite()), defineWebPage()])
    useGtmAppInit()
    useHotjar()
    useKelkooLeadTag()
    useMetaPixelAppInit()
    useGoogleSignIn()
  },
})
